module.exports = __webpack_public_path__ + "open-sans-semibold.33b67be977acf26d6696.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/google/open-sans-semibold.woff
// module id = 707
// module chunks = 2